<div class="flex w-full items-center gap-1">
  <div class="rounded-[9px] bg-states-red px-2 py-1 text-h7 font-semibold text-text-white shadow-item-status-red">
    {{ 'collab_new_message_marker' | translate }}
  </div>
  <div class="h-[2px] w-full rounded bg-states-red"></div>
</div>
